export const NOT_ALLOWED_ACCOUNT_STATUS = [
  "Suspended",
  "Frozen",
  "Closing",
  "Closed",
];
